
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Force production mode for better performance
if (import.meta.env.DEV) {
  console.log('Running in development mode');
} else {
  console.log('Running in production mode');
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
